var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.97352 11V0H6.45813V11H4.97352ZM0.21582 6.23855V4.76145H11.2158V6.23855H0.21582Z","fill":"#212121","opacity":".4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }